import { captureException } from '@sentry/nextjs';
import { get } from 'src/utils/api';

export async function findIfMemberIsRestricted(slug: string, memberId: number): Promise<boolean> {
  try {
    const { data } = await get(`private/members/${slug}/restrict/${memberId}`);
    return data?.isRestricted || false;
  } catch (ex) {
    captureException(ex);
    return false;
  }
}
